module.exports = __webpack_public_path__ + "img/heart.472608c2.gif";